import { useEffect, useState } from "react";
import { useLang } from "../contexts/LanguageContext";
import { fetchArtworks } from "../lib/api";
import { Reveal } from "../components/site/Reveal";
import { ArtworkCard } from "../components/site/ArtworkCard";

export default function Gallery() {
  const { t } = useLang();
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArtworks()
      .then((d) => setArtworks(d))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page">
      <section className="pt-16 pb-12 md:pt-20 md:pb-16">
        <div className="container-art">
          <Reveal>
            <div className="overline mb-6">{t.gallery_page.overline}</div>
            <h1 className="font-heading text-5xl md:text-7xl font-light tracking-tighter leading-[1.02] max-w-3xl text-balance">
              {t.gallery_page.title}
            </h1>
            <p className="mt-8 max-w-xl text-base font-light text-foreground/70 leading-relaxed">
              {t.gallery_page.lead}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-24 border-t border-border">
        <div className="container-art">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="aspect-[4/5] bg-sand animate-pulse" />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 md:gap-x-12 gap-y-20 md:gap-y-28">
              {artworks.map((a, i) => {
                const layouts = [
                  "md:col-span-6",
                  "md:col-span-5 md:col-start-8 md:mt-24",
                  "md:col-span-7",
                  "md:col-span-4 md:col-start-9 md:mt-20",
                  "md:col-span-6",
                  "md:col-span-5 md:col-start-7 md:mt-32",
                ];
                const aspects = [
                  "aspect-[4/5]",
                  "aspect-[3/4]",
                  "aspect-[5/4]",
                  "aspect-[3/4]",
                  "aspect-[1/1]",
                  "aspect-[4/5]",
                ];
                return (
                  <Reveal
                    key={a.id}
                    delay={(i % 3) * 0.08}
                    className={layouts[i % layouts.length]}
                  >
                    <ArtworkCard artwork={a} aspect={aspects[i % aspects.length]} />
                  </Reveal>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
